<div id="transcript">
  <textarea [(ngModel)]="response.corrected_transcript" class="longer_input" rows="10"
    placeholder="transcript of the audio" title="Correct the transcription if needed."></textarea>
  <span (click)="updateTranscript()" class="save btn">Save</span>
</div>
<div id="player">
  <div class="image_button">
    <img src="/images/cancel.svg" (click)="Cancel()" title="Cancel">
  </div>
  <div *ngIf="isPlaying(); else notPlaying" class="image_button">
    <img src="/images/pause.svg" (click)="Pause()" title="Pause">
  </div>
  <ng-template #notPlaying>
    <div class="image_button">
      <img src="/images/play.svg" (click)="Play()" title="Play">
    </div>
  </ng-template>
  <div class="image_button">
    <img src="/images/stop.svg" (click)="Stop()" title="Stop">
  </div>
  <div class="image_button">
    <a href="/api/private/r/audio/{{response.id}}/m4a/{{response.topic}}-{{response.id}}-{{response.name}}.m4a"
      download="{{response.topic}}-{{response.id}}-{{response.name}}.m4a" target="_blank">
      <img src="/images/download.svg" title="Download">
    </a>

  </div>
  <div id="times">
    at <span class="time">{{lastPosition | secs}}</span>
    of <span class="time">{{duration | secs}}</span>
    seconds
  </div>
</div>
<div id="progressbar">
  <span id="progress" [style.width.%]="progressBarPercent()"></span>
</div>